/* Linsoul product content sections: expert review filters, click-to-load videos, Show more; FAQ filters. */
(() => {
  'use strict';

  function initExperts(root) {
    const cards = [...root.querySelectorAll('[data-lsx-card]')];
    const result = root.querySelector('[data-lsx-result]');
    const more = root.querySelector('[data-lsx-more]');
    const initial = Number(root.dataset.initial) || cards.length;
    let filter = 'all';
    let expanded = false;

    const render = () => {
      const matching = cards.filter((card) => filter === 'all' || card.dataset.format === filter);
      cards.forEach((card) => { card.hidden = true; });
      matching.forEach((card, i) => { card.hidden = !expanded && i >= initial; });
      if (result) {
        result.textContent = matching.length === 1
          ? root.dataset.labelCountOne
          : (root.dataset.labelCount || '').replace('[count]', matching.length);
      }
      if (more) more.closest('.lsx-more').hidden = expanded || matching.length <= initial;
      root.querySelectorAll('[data-lsx-group]').forEach((group) => {
        group.hidden = !group.querySelector('[data-lsx-card]:not([hidden])');
      });
    };

    root.querySelectorAll('[data-lsx-filter]').forEach((button) => button.addEventListener('click', () => {
      filter = button.dataset.lsxFilter;
      root.querySelectorAll('[data-lsx-filter]').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
      render();
    }));

    more?.addEventListener('click', () => {
      const firstHidden = cards.find((card) => card.hidden && (filter === 'all' || card.dataset.format === filter));
      expanded = true;
      render();
      firstHidden?.querySelector('a, button')?.focus({ preventScroll: true });
    });

    const modal = root.querySelector('[data-lsx-modal]');
    const slot = modal?.querySelector('[data-lsx-modal-frame]');
    let opener = null;
    const fill = (selector, text) => {
      const node = modal.querySelector(selector);
      if (!node) return;
      node.textContent = text || '';
      node.hidden = !text;
    };
    const closeModal = () => {
      if (!modal?.open) return;
      modal.close();
    };
    modal?.addEventListener('close', () => {
      slot.replaceChildren();
      document.documentElement.classList.remove('lsx-modal-lock');
      opener?.focus({ preventScroll: true });
      opener = null;
    });
    modal?.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    modal?.querySelector('[data-lsx-modal-close]')?.addEventListener('click', closeModal);

    root.querySelectorAll('[data-lsx-video]').forEach((cover) => cover.addEventListener('click', () => {
      const id = encodeURIComponent(cover.dataset.lsxVideo);
      const start = Number(cover.dataset.lsxStart) || 0;
      const frame = document.createElement('iframe');
      frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1${start ? `&start=${start}` : ''}`;
      frame.title = `${root.dataset.labelPlayer || ''} ${cover.dataset.lsxTitle || ''}`.trim();
      frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      frame.allowFullscreen = true;
      frame.className = 'lsx-frame';
      if (!modal || typeof modal.showModal !== 'function') {
        cover.replaceWith(frame);
        frame.focus();
        return;
      }
      opener = cover;
      fill('[data-lsx-modal-title]', cover.dataset.lsxTitle);
      fill('[data-lsx-modal-by]', cover.dataset.lsxBy);
      fill('[data-lsx-modal-summary]', cover.dataset.lsxSummary);
      const link = modal.querySelector('[data-lsx-modal-link]');
      if (link) {
        link.href = cover.dataset.lsxUrl || `https://www.youtube.com/watch?v=${id}`;
      }
      slot.replaceChildren(frame);
      document.documentElement.classList.add('lsx-modal-lock');
      modal.showModal();
      modal.querySelector('[data-lsx-modal-close]')?.focus({ preventScroll: true });
    }));

    render();
  }

  function initFaq(root) {
    const groups = [...root.querySelectorAll('[data-lsf-group]')];
    root.querySelectorAll('[data-lsf-filter]').forEach((button) => button.addEventListener('click', () => {
      const value = button.dataset.lsfFilter;
      root.querySelectorAll('[data-lsf-filter]').forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
      groups.forEach((group) => { group.hidden = value !== 'all' && group.dataset.lsfGroup !== value; });
    }));
  }

  function initUnboxing(root) {
    root.querySelectorAll('[data-lsu-video]').forEach((cover) => cover.addEventListener('click', () => {
      const id = encodeURIComponent(cover.dataset.lsuVideo);
      const start = Number(cover.dataset.lsuStart) || 0;
      const frame = document.createElement('iframe');
      frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&playsinline=1${start ? `&start=${start}` : ''}`;
      frame.title = `${root.dataset.labelPlayer || ''} ${cover.dataset.lsuTitle || ''}`.trim();
      frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      frame.allowFullscreen = true;
      frame.className = 'lsx-frame lsu-frame';
      cover.replaceWith(frame);
      frame.focus();
    }));
  }

  const init = () => {
    document.querySelectorAll('[data-lsu]').forEach((root) => {
      if (root.dataset.lsuReady) return;
      root.dataset.lsuReady = '1';
      initUnboxing(root);
    });
    document.querySelectorAll('[data-lsx]').forEach((root) => {
      if (root.dataset.lsxReady) return;
      root.dataset.lsxReady = '1';
      initExperts(root);
    });
    document.querySelectorAll('[data-lsf]').forEach((root) => {
      if (root.dataset.lsfReady) return;
      root.dataset.lsfReady = '1';
      initFaq(root);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
